import NavBar from './Navbar';
import { Route, Routes, BrowserRouter as Router, Navigate } from "react-router-dom";
// import { UserContext } from '../context';
// import { useContext } from 'react';
import MapPage from '../pages/MapPage';
import StartPage from '../pages/StartPage';
import ManagementPage from '../pages/ManagementPage';
import AccountingsPage from '../pages/AccountingsPage';
import AccountingsViewPage from '../pages/AccountingsViewPage'
import TasksPage from '../pages/TasksPage';
import ObjectsReestrPage from '../pages/ObjectsReestrPage';
import FieldWorksPage from '../pages/FieldWorksPage';
import ObjectsReestrPageV3 from '../pages/ObjectsReestrPageV3';

const RouterContent = () => {
    // const { userPayload } = useContext(UserContext)
    // const { isAuth } = userPayload
    return (
        <Routes>
            
            {/* <Route path="map" element={isAuth ? <MapPage /> : <Navigate to='/login' />} /> */}
            {/* <Route path="adm" element={isAuth && isAdmin ? <AdminPage /> : <Navigate to='/login' />} /> */}
            {/* <Route path="login" element={<LoginPage />} /> */}
            {/* <Route path="*" element={isAuth  ? <MapPage /> : <Navigate to='/login' />} /> */}
            <Route path="/" element={<StartPage/>} />
            <Route path="*" element={<StartPage/>} />
            <Route path="an" element={<MapPage/>} />
            <Route path="management" element={<ManagementPage/>} />
            <Route path="accountings" element={<AccountingsPage/>} />
            <Route path="tasks" element={<TasksPage/>} />
            <Route path="objects_reestr_old" element={<ObjectsReestrPage />} />
            <Route path="objects_reestr" element={<ObjectsReestrPageV3 />} />
            <Route path="accountings_view" element={<AccountingsViewPage />} />
            <Route path="field_works" element={<FieldWorksPage />} />
            {/* <Route path="*" element={<MapPage/>} /> */}
        </Routes>



    )
}

const AppRouter = () => {

    return (
        // <Container fluid>
            <Router>
                <NavBar />
                <RouterContent />
                
            </Router>
        // </Container>
    )
}

export default AppRouter;